import { CALL_API } from './api'
import moment from 'moment-timezone'
import {
    setRefreshToken,
    CORE_API_ENDPOINT,
    MIN_EXPIRE_TOKEN,
    getAllToken
} from 'Lib'
import axios from 'axios'

export default store => next => async action => {
    try {
        const entry = action[CALL_API]
            , allToken = getAllToken()
            , expires = allToken.expires_on
            , userId = allToken.userId
            , refreshToken = allToken.refresh_token

        if (typeof entry !== 'object' || !expires) {
            return next(action)
        }

        const duration = moment.unix(expires).diff(moment(), "m")
        if (duration <= MIN_EXPIRE_TOKEN) {
            const options = {
                method: "POST",
                url: `${CORE_API_ENDPOINT}/user/refreshtoken`,
                headers: {
                    'Content-Type': 'application/json'
                },
                data: {
                    refreshToken: refreshToken,
                    userId: userId
                }
            }
            let res = await axios(options)
            if (!!res && !!res.data) {
                let data = null
                if ("value" in res.data) {
                    data = res.data
                }
                if (!!data) {
                    await setRefreshToken(data);
                    return next(action)
                } else {
                    throw new Error("Refresh token fail")
                }
            } else {
                throw new Error("Token is Expired")
            }
            // await fetch(`${CORE_API_ENDPOINT}/user/refreshtoken`, {
            //     method: 'POST',
            //     headers: {
            //         'Content-Type': 'application/json',
            //     },
            //     body: JSON.stringify({ refreshToken: refreshToken, userId: userId })
            // })
            //     .then(res => res.json())
            //     .then(json => setRefreshToken(json))
        } else {
            return next(action)
        }
    } catch (error) {
        // console.log(error)
        return window.location.replace('/sessionExpire')
    }
}


// WEBPACK FOOTER //
// ./src/middlewares/checkToken.js